import { motion } from "framer-motion";
import { Calculator, Crosshair, Target, ShieldCheck } from "lucide-react";

const CHAPTERS = [
    { n: "01", icon: Calculator, title: "MATH OVER EMOTION", text: "Every selection starts from numbers — expected goals, chance creation, conversion rates and market pricing. Feelings never make the cut." },
    { n: "02", icon: Crosshair, title: "ONE SINGLE, EVERY DAY", text: "One match, one clear selection. We focus on quality over quantity — a single professionally analysed match, delivered every day." },
    { n: "03", icon: Target, title: "ONE DOUBLE, EVERY DAY", text: "Two matches, one combined ticket. We focus on quality over quantity — a single professionally analysed double, delivered daily." },
    { n: "04", icon: ShieldCheck, title: "TRANSPARENT RECORDS", text: "Every double we release is archived with date, selections, odds and final score. Our record is open for subscribers to audit." },
];

export const Manifesto = () => (
    <section data-testid="manifesto-section" className="relative py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
                className="mb-14"
            >
                <div className="font-mono text-[11px] tracking-[0.3em] text-bn-blue font-semibold mb-4">OUR METHOD</div>
                <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-white max-w-2xl">
                    Analysis first. <span className="text-slate-500">Discipline always.</span>
                </h2>
            </motion.div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-bn-line">
                {CHAPTERS.map((c, i) => (
                    <motion.div
                        key={c.n}
                        data-testid={`manifesto-chapter-${c.n}`}
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.7, delay: i * 0.12 }}
                        className="group relative border-b border-r border-bn-line p-8 lg:p-9 hover:bg-bn-card/60 transition-colors duration-500"
                    >
                        <div className="flex items-start justify-between">
                            <span className="font-display font-extrabold text-4xl text-white/10 group-hover:text-bn-blue/40 transition-colors duration-500">{c.n}</span>
                            <c.icon className="w-5 h-5 text-bn-blue" />
                        </div>
                        <h3 className="mt-8 font-display font-bold text-lg text-white tracking-tight">{c.title}</h3>
                        <p className="mt-3 text-sm text-slate-400 leading-relaxed">{c.text}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    </section>
);
